import React from 'react';
import { ResourceColumn, ResourceListPage } from '../../components/resource/ResourceListPage';
import { EstoqueProduto } from '../../types/estoque';
import { estoqueProdutosService } from '../../services';

const columns: ResourceColumn<EstoqueProduto>[] = [
  { header: 'Código', accessor: 'produto_codigo' },
  { header: 'Produto', accessor: 'produto_descricao' },
  { header: 'Armazém', accessor: 'armazem_nome' },
  { header: 'Localização', accessor: 'localizacao' },
  { header: 'Disponível', accessor: 'quantidade_disponivel', align: 'right' },
];

export const EstoqueProdutosListPage: React.FC = () => {
  return (
  <ResourceListPage
    title="Estoque de produtos"
    description="Inventario de produtos."
    columns={columns}
    service={estoqueProdutosService}
    enableEdit={false}
    enableDelete={false}
    searchParamKey="q"
  />
  );
};
